"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
function generatePayload(values) {
  var payload = {};
  var {
    children
  } = values;

  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0) {
      payload[fieldName] = forcedValue;
    }
  }
  var collegeCostMap = {
    'public 2-year': 14440,
    'public 4-year in-state': 24920,
    'public 4-year out-of-state': 44090,
    'private 4-year': 58600
  };
  var yearsCollegeMap = {
    'public 2-year': 2,
    'public 4-year in-state': 4,
    'public 4-year out-of-state': 4,
    'private 4-year': 4
  };

  // Start all REQUIRED general fields
  setFieldIfExists("collegeInflation", (0, _utils.parseCurrencyString)(null, values.collegeInflation));
  setFieldIfExists("currentSaving", (0, _utils.parseCurrencyString)(null, values.savings));
  setFieldIfExists("rateReturn", (0, _utils.parseCurrencyString)(null, values.rateReturn));
  setFieldIfExists("startIn", (0, _utils.parseCurrencyString)(null, values.startIn));

  // Loop through all child related fields
  children.forEach((child, i) => {
    // The first time through the app, a user will only be able to enter the age for thier children
    // All other fields we will use the default values for the first child set in initialValues
    // A user can then go into the refine modal and change specific information related to each child
    // which we will then want to use instead of the
    setFieldIfExists("childAge".concat(i + 1), (0, _utils.parseCurrencyString)(null, child.childAge));
    setFieldIfExists("collegeAge".concat(i + 1), (0, _utils.parseCurrencyString)(null, child.collegeAge));
    setFieldIfExists("collegeCost".concat(i + 1), collegeCostMap[child.collegeTerm]);
    setFieldIfExists("fundPercent".concat(i + 1), child.fundPercent);
    setFieldIfExists("yearsCollege".concat(i + 1), yearsCollegeMap[child.collegeTerm]);
  });
  return payload;
}